module.exports = __webpack_public_path__ + "static/assets/d908f807e46864bc22e64c6d186ca2fa.png";